<template>
  <div>
    <px-view-header title="Fornecedores" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-listagem-fornecedores-header :on-click-refresh="onClickRefresh"
                                     :on-change-filter="onChangeFilter"
                                     @change="onChangeFilter"/>
    <px-lista-fornecedor :fornecedores="fornecedores"
                         :loading="loading"
                         :on-change-options="onChangeOptions"
                         :options-list="optionsList"
                         :footer-options="footerOptions"
                         @update="onClickRefresh"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-fornecedores/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import ListagemFornecedoresHeader from './ListagemFornecedoresHeader.vue';
import ListaFornecedor from './ListaFornecedor.vue';
import GestaoFornecedorService from './gestao-fornecedor-service';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      breadcrumbs: [
        { text: 'Gestão de fornecedores' },
        { text: 'Fornecedores' },
      ],
      fornecedores: {
        content: [],
        total: 0,
      },
      loading: false,
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemFornecedores', ['stringFilter', 'listOptions']),
    ...mapGetters('entidade', ['idEntidade']),
    ...mapGetters('user', ['user']),
  },
  methods: {
    ...mapActions('listagemFornecedores', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getFornecedores();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getFornecedores();
    },
    onClickRefresh() {
      this.getFornecedores();
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getFornecedores() {
      this.loading = true;

      const { limit, offset } = this.listOptions;
      return GestaoFornecedorService.list({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.fornecedores = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxListagemFornecedoresHeader: ListagemFornecedoresHeader,
    pxListaFornecedor: ListaFornecedor,
  },
};
</script>
